import { render, staticRenderFns } from "./main-header-login.vue?vue&type=template&id=7c234f30"
import script from "./main-header-login.vue?vue&type=script&lang=js"
export * from "./main-header-login.vue?vue&type=script&lang=js"
import style0 from "./main-header-login.vue?vue&type=style&index=0&id=7c234f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports